module.exports = __webpack_public_path__ + "img/linkedin.40df4310.png";